import { Component, Vue } from 'vue-property-decorator';
import { WELCOME_PROJECT_LIST, HIVE_STATISTICS_TEXT, HIVE_GUIDELINE_LINK } from '@/constants';
import { HiveStatistics, UserDTO, WelcomeProject } from '@/models';
import { fetchHiveStatistics } from '@/services';
import WelcomeProjectCard from '@/components/pages/welcome/welcome-project-card/WelcomeProjectCard.vue';

@Component({
  components: {
    WelcomeProjectCard
  }
})
export default class Welcome extends Vue {
  private currentUser: UserDTO = {} as UserDTO;
  private projects = Object.values(WELCOME_PROJECT_LIST).map(project => {
    return {
      id: project.title + project.orgId,
      ...project,
      flipped: false
    };
  });

  private statistics = {} as HiveStatistics;
  private keys = [] as Array<keyof HiveStatistics>;
  private hiveText = HIVE_STATISTICS_TEXT;

  async created(): Promise<void> {
    window.scroll(0, 0);
    const { data } = await fetchHiveStatistics();
    this.statistics = data;
    this.keys = Object.keys(this.statistics) as Array<keyof HiveStatistics>;
    this.currentUser = this.$store.getters['app/currentUser'];
  }

  openOnBoardingDialog(): void {
    this.$store.commit('app/setProductTutorialDialogShown', true);
  }

  openGuideLinePage(): void {
    window.open(HIVE_GUIDELINE_LINK.filter(x => x.org_id === this.currentUser.orgId)[0].link, '_blank');
  }

  toggleCard(card: WelcomeProject): void {
    const foundProject = this.projects.find(
      project => project.title === card.title && project.orgId === this.currentUser.orgId
    );
    if (foundProject && foundProject?.description) {
      foundProject.flipped = !card.flipped;
    }
  }
}
